module.exports = __webpack_public_path__ + "img/BJames.0b0e45f5.jpeg";